import React__default from 'react';
import { DotsLoader } from '../../dots-loader/index.js';
import { ListElemText } from '../list-content-elements/index.js';
import '../../../../tslib.es6-fe064bda.js';
import '../../../../index-250ace75.js';
import '../../../../_commonjsHelpers-1a7a244d.js';

var ListItemRowLoader = function () {
    return (React__default.createElement("div", { className: 'list-item-row-loader' },
        React__default.createElement(ListElemText, { forSaving: true },
            React__default.createElement(DotsLoader, null))));
};

export { ListItemRowLoader };
